<template>
  <div class="mb-8">
    <div v-if="Array.isArray(value)">
      <template v-for="(conditional, index) in value">
        <v-card :key="index" color="grey lighten-4 mt-4" outlined>
          <v-card-text>
            <div class="och-field--conditional mb-4">
              <p class="font-weight-bold mb-2 primary--text">IF</p>
              <conditional-if
                :entityName="entityName"
                :conditional="conditional"
                :optionAttributeEntityName="optionAttributeEntityName"
                @update="conditional => update(conditional, index)"
              ></conditional-if>
              <v-divider class="mt-7 mb-5"></v-divider>
              <p class="font-weight-bold mb-0 secondary--text">THEN</p>
              <conditional-then
                :attributeName="attributeName"
                :conditional="conditional"
                :entityName="entityName"
                :ruleList="ruleList"
                v-model="attributeMap"
              >
              </conditional-then>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="mt-0 pt-0">
            <v-spacer></v-spacer>
            <v-btn
              class="mt-2"
              color="primary"
              text
              @click="value.splice(index, 1)"
              ><v-icon small class="mr-2">fas fa-times</v-icon>Remove
              Conditional</v-btn
            >
          </v-card-actions>
        </v-card>
      </template>
    </div>

    <v-btn
      class="mt-5"
      color="primary"
      outlined
      @click="Array.isArray(value) ? value.push({}) : (value = [{}])"
      >Add Conditional</v-btn
    >
  </div>
</template>

<script>
import ConditionalIf from "./ConditionalIf";
import ConditionalThen from "./ConditionalThen";

import formElementMixin from "./formElementMixin";

export default {
  components: {
    ConditionalIf,
    ConditionalThen,
  },
  methods: {
    update(conditional, index) {
      this.$set(this.value, index, conditional);
    },
  },
  mixins: [formElementMixin],
  props: {
    optionAttributeEntityName: {
      required: true,
      type: String,
    },
    entityName: {
      required: true,
    },
    mode: {
      default: "create",
      type: String,
      validator: function (value) {
        return ["create", "update"].includes(value);
      },
    },
  },
};
</script>
